/**
 * User reporting — bug reports and inappropriate-content (post/comment) reports.
 *
 * For now everything opens a pre-filled email (`mailto:`), which works offline-ish
 * and needs no backend. The target address comes from `VITE_REPORT_EMAIL`.
 *
 * TODO (project goal): replace the mailto path with a Jira ticket created via the
 * backend (a `reportContent`/`reportProblem` mutation) so reports are tracked.
 */

const REPORT_EMAIL = import.meta.env.VITE_REPORT_EMAIL ?? 'support@thruhiker.app'

/** Context appended to every report so we can reproduce the issue. */
function diagnostics(): string {
	return [
		'',
		'— — —',
		`URL: ${typeof location !== 'undefined' ? location.href : 'n/a'}`,
		`Browser: ${typeof navigator !== 'undefined' ? navigator.userAgent : 'n/a'}`,
		`Time: ${new Date().toISOString()}`,
	].join('\n')
}

function openMail(subject: string, body: string): void {
	const url = `mailto:${REPORT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
	if (typeof window !== 'undefined') window.location.href = url
}

/** Report a bug / problem with the app. */
export function reportBug(): void {
	openMail(
		'[Thruhiker] Bug report',
		`Please describe the problem as precisely as you can (what were you doing, what happened?):\n\n${diagnostics()}`
	)
}

/** Report an inappropriate post or comment. `reason` is optional pre-filled text. */
export function reportContent(kind: 'Post' | 'Comment', id: string, reason = ''): void {
	openMail(
		`[Thruhiker] Report ${kind}`,
		`Reported ${kind} (ID: ${id}).\n\nReason:\n${reason || '(please describe)'}\n${diagnostics()}`
	)
}
